export default "__VITE_ASSET__6109cc90__"